import { httpGet, httpPost } from '../utils/cms-axios';

export async function getTemplateCodeV2({ address, chat_token, cms_token }) {
  const res = await fetch(`${address}/template/chat/${chat_token}/v2/get_code`, {
    headers: {
      Authorization: `Bearer ${cms_token}`,
    },
  });
  if (!res.ok) {
    throw new Error(`getTemplateCodeV2 failed: ${res.status}`);
  }
  return res.json();
}

export function getAiSaver() {
  return httpGet("/ai-api-saver-address", {}, {}, "");
}

export function createChatTokenSimple(data) {

  const {site_id, address, token} = data

  return httpPost("/chat/create_token", {
    "site_id": site_id,
  }, {
    "Authorization": `Bearer ${token}`,
  }, `${address}`);
}

export function createChatTokenTemplateSimple(data) {

  const {site_id, address, token, page_pkg_code, template_pkg_code, page_type, is_list_page, template_page_id, template_layout_code} = data

  return httpPost("/template/chat/create_token", {
    "site_id": site_id,
    "page_pkg_code": page_pkg_code,
    "template_pkg_code": template_pkg_code,
    "page_type": page_type,
    "is_list_page": is_list_page,
    "template_page_id": template_page_id,
    "template_layout_code": template_layout_code,
  }, {
    "Authorization": `Bearer ${token}`,
  }, `${address}`);
}

export function createChatTokenConfigSimple(data) {

  const {site_id, address, token} = data

  return httpPost("/config/chat/create_token", {
    "site_id": site_id,
  }, {
    "Authorization": `Bearer ${token}`,
  }, `${address}`);
}

export function getSiteConfig(data) {
  const {address, chat_token, cms_token} = data

  return httpGet(`/config/chat/${chat_token}/get_site_config`, {}, {
    "Authorization": `Bearer ${cms_token}`,
  }, `${address}`);
}

export function getTemplateCode(data) {

  const {address, chat_token, cms_token} = data

  return httpGet(`/template/chat/${chat_token}/get_code`, {}, {
    "Authorization": `Bearer ${cms_token}`,
  }, `${address}`);
}

export function commitCreateDoc(data) {

    const {address, chat_token, cms_token, doc} = data

    return httpPost(`/template/chat/${chat_token}/commit_doc`, {
      "doc": doc,
    }, {
      "Authorization": `Bearer ${cms_token}`,
    }, `${address}`);
}

export function createSummary(data) {

  const {address, cms_token, site_id, post_type_id, post_data} = data

  return httpPost(`/tool/post/create_summary`, {
    "site_id": site_id,
    "post_type_id": post_type_id,
    "post_data": post_data,
  }, {
    "Authorization": `Bearer ${cms_token}`,
  }, `${address}`);
}

export function createTextGrammar(data) {
  const {address, cms_token, text} = data

  return httpPost(`/tool/text_grammar/check`, {
    "text": text,
  }, {
    "Authorization": `Bearer ${cms_token}`,
  }, `${address}`);
}

export function createImage(data) {
  const {address, cms_token, site_id, post_type_id, post_data, image_style} = data

  return httpPost(`/tool/post_create_images/create_image`, {
    "site_id": site_id,
    "post_type_id": post_type_id,
    "post_data": post_data,
    "image_style": image_style, // 画像スタイルパラメータを追加
  }, {
    "Authorization": `Bearer ${cms_token}`,
  }, `${address}`);
}

export function createQAFromText(data) {
  const {address, cms_token, site_id, text} = data

  return httpPost(`/tool/qa_generation/run-text`, {
    "data": text,
  }, {
    "Authorization": `Bearer ${cms_token}`,
    "SiteId": site_id,
  }, `${address}`);
}


export function createQATask(data) {
  const {address, cms_token, site_id, name} = data;

  return httpPost('/tool/qa_generation/task/create', {
    name,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function uploadQATaskFile(data) {
  const {address, cms_token, site_id, task_id, file} = data;
  
  const formData = new FormData();
  formData.append('task_id', task_id);
  formData.append('file', file);
  
  return httpPost('/tool/qa_generation/task/upload', 
    formData, 
    {
      'Authorization': `Bearer ${cms_token}`,
      'SiteId': site_id,
      'Content-Type': 'multipart/form-data',
    }, 
    `${address}`,
    true // formDataフラグ
  );
}

export function startQATask(data) {
  const {address, cms_token, site_id, task_id} = data;

  return httpPost('/tool/qa_generation/task/start', {
    task_id,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function getQATaskDetails(data) {
  const {address, cms_token, site_id, task_id} = data;

  return httpGet(`/tool/qa_generation/task/${task_id}`, {}, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function getQATaskList(data) {
  const {address, cms_token, site_id, limit, last_doc_id} = data;
  
  let url = '/tool/qa_generation/tasks/list';
  const params = [];
  
  if (limit !== undefined) {
    params.push(`limit=${limit}`);
  }
  
  if (last_doc_id !== undefined) {
    params.push(`last_doc_id=${last_doc_id}`);
  }
  
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return httpGet(url, {}, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function deleteQATaskFile(data) {
  const {address, cms_token, site_id, task_id, file_name} = data;

  return httpPost('/tool/qa_generation/task/delete-file', {
    task_id,
    file_name,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function getQAList(data) {
  const {address, cms_token, site_id, task_id, limit, last_doc_id, source, status} = data;
  
  let url = `/tool/qa_generation/qa/list`;
  const params = [`task_id=${task_id}`];
  
  if (limit !== undefined) {
    params.push(`limit=${limit}`);
  }
  
  if (last_doc_id !== undefined) {
    params.push(`last_doc_id=${last_doc_id}`);
  }
  
  if (source !== undefined) {
    params.push(`source=${source}`);
  }
  
  if (status !== undefined) {
    params.push(`status=${status}`);
  }
  
  url += `?${params.join('&')}`;

  return httpGet(url, {}, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function exportQAListCSV(data) {
  const {address, cms_token, site_id, task_id, source, status} = data;
  
  let url = `/tool/qa_generation/qa/export-csv`;
  const params = [`task_id=${task_id}`];
  
  if (source !== undefined) {
    params.push(`source=${source}`);
  }
  
  if (status !== undefined) {
    params.push(`status=${status}`);
  }
  
  url += `?${params.join('&')}`;

  return httpGet(url, {}, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`, true); // blobフラグをtrueに設定
}

export function importQAListCSV(data) {
  const {address, cms_token, site_id, task_id, file} = data;
  
  const formData = new FormData();
  formData.append('task_id', task_id);
  formData.append('file', file);
  
  return httpPost('/tool/qa_generation/qa/import-csv', 
    formData, 
    {
      'Authorization': `Bearer ${cms_token}`,
      'SiteId': site_id,
      'Content-Type': 'multipart/form-data',
    }, 
    `${address}`,
    true // formDataフラグ
  );
}

export function updateQA(data) {
  const {address, cms_token, site_id, qa_id, task_id, question, answer, status, post_type_id, post_id} = data;
  
  return httpPost('/tool/qa_generation/qa/update', {
    qa_id,
    task_id,
    question,
    answer,
    status,
    post_type_id,
    post_id,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function updateQAStatuses(data) {
  const {address, cms_token, site_id, qa_ids, task_id, status} = data;
  
  return httpPost('/tool/qa_generation/qa/update-statuses', {
    qa_ids,
    task_id,
    status,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function updateTemplateDoc(data) {
  const {address, cms_token, site_id, version} = data;
  
  return httpPost('/tool/template_doc/update', {
    version,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

// ---------------------------------------------------------------------------
// Design Editor Chat API
// ---------------------------------------------------------------------------

export function createDesignEditorChatToken(data) {
  const { site_id, address, token, template_pkg_code, page_pkg_code, theme_code, llm_provider } = data;

  return httpPost('/design-editor/chat/create_token', {
    site_id,
    template_pkg_code,
    page_pkg_code,
    theme_code,
    // 使用する LLM。会話単位で固定されるため作成時にしか指定できない。
    llm_provider: llm_provider || '',
  }, {
    'Authorization': `Bearer ${token}`,
  }, `${address}`);
}

// 「この人がこのテーマの編集画面を開いている」印を後端へ打つ。
// 編集画面を開いている間 20 秒ごとに呼ぶ（design-editor-chat.js の PRESENCE_TOUCH_MS）。
// 走っているターンは、この印が 150 秒途切れると後端が
// 「操作画面が閉じられたため中断しました」で止める。会話（chat_token）には紐づかない。
export function touchDesignEditorPresence(data) {
  const { site_id, theme_code, address, token } = data;
  return httpPost('/design-editor/chat/presence', {
    site_id,
    theme_code: theme_code || '',
  }, {
    'Authorization': `Bearer ${token}`,
  }, `${address}`);
}

// サイト内・自分の会話を全部返す（テーマでは絞らない）。テーマの区別は
// 各要素の theme_code で行い、編集中テーマと違う会話は閲覧のみになる。
export function listDesignEditorChatTokens(data) {
  const { site_id, address, token } = data;
  const url = `/design-editor/chat/list_tokens?site_id=${encodeURIComponent(site_id)}`;
  return httpGet(url, {}, { 'Authorization': `Bearer ${token}` }, `${address}`);
}

export async function getDesignEditorChatCode({ address, chat_token, cms_token }) {
  const res = await fetch(`${address}/design-editor/chat/${chat_token}/v3/get_code`, {
    headers: { Authorization: `Bearer ${cms_token}` },
  });
  if (!res.ok) throw new Error(`getDesignEditorChatCode failed: ${res.status}`);
  return res.json();
}

export async function getDesignEditorChatHistory({ address, chat_token, cms_token }) {
  const res = await fetch(`${address}/design-editor/chat/${chat_token}/v3/history/list`, {
    headers: { Authorization: `Bearer ${cms_token}` },
  });
  if (!res.ok) throw new Error(`getDesignEditorChatHistory failed: ${res.status}`);
  return res.json();
}

// ---------------------------------------------------------------------------
// 「AI変更を破棄」の共通部分
// ---------------------------------------------------------------------------
// ⚠ 破棄の失敗を握り潰してはいけない。
//   呼び出し側は「後端で確実に消えた」ことを前提に前端のキャッシュを捨てて
//   保存済み表示へ落とす。失敗を黙って通すと、画面は破棄されたように見えるが
//   後端の作業コピーは生きているので、**リロードすると AI 変更が復活する**。
//   ここで必ず投げて、呼び出し側にエラー表示させる。
//
// status は HTTP ではなく body に入る（res.ok だけ見ても "SAVER_ERROR" を
// 成功と誤認する）。AI_BUSY は「推論中なので今は破棄できない」の意味で、
// 再試行すれば通るため呼び出し側が文言を出し分けられるよう印を付ける。
export const AI_DISCARD_BUSY = 'AI_BUSY';

export class AiDiscardError extends Error {
    constructor(message, { status = '', busy = false } = {}) {
        super(message);
        this.name = 'AiDiscardError';
        this.status = status;
        this.busy = busy;
    }
}

// 応答が返らないときに何秒で諦めるか。
//
// ⚠ 既定は「諦めない」。ユーザーが押した破棄は、待ってでも結果を知りたい
//   （成功したかどうかが判らないまま閉じると、作業コピーが生きているのに
//   消えたと思い込む）。
//
//   timeoutMs を渡すのは**ユーザーを待たせてはいけない後始末**だけ。
//   具体的には保存後の discard(reason='saved') —— 本体の保存は既に
//   成功しているのに、AI サーバーが無応答だと Ctrl+S が回り続ける。
async function postDiscard(url, cms_token, body, { timeoutMs } = {}) {
    let res;
    const controller = timeoutMs ? new AbortController() : null;
    const timer = controller
        ? setTimeout(() => controller.abort(), timeoutMs)
        : null;
    try {
        res = await fetch(url, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${cms_token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            signal: controller ? controller.signal : undefined,
        });
    } catch (e) {
        throw new AiDiscardError(
            e?.name === 'AbortError'
                ? 'AI サーバーの応答がありませんでした。'
                : 'AI サーバーに接続できませんでした。');
    } finally {
        if (timer) clearTimeout(timer);
    }
    if (!res.ok) {
        throw new AiDiscardError(`破棄に失敗しました (HTTP ${res.status})`);
    }
    const data = await res.json().catch(() => null);
    const status = data?.status || '';
    if (status === AI_DISCARD_BUSY) {
        throw new AiDiscardError(
            data?.error?.error
            || 'AI の応答中は破棄できません。完了後にもう一度お試しください。',
            { status, busy: true },
        );
    }
    if (status && status !== 'OK') {
        throw new AiDiscardError(
            data?.error?.error || '破棄に失敗しました。', { status },
        );
    }
    return data || {};
}

// 「AI変更を破棄」を押したときに送る reason。
// 後端はこれを見て **AI が最初に触る直前（pre_ai）へ戻す**。
// 'saved' / 'deleted' は未保存周期の終わりで、作業コピーを控えごと畳む。
export const DISCARD_REASON_AI = 'ai';

// ---------------------------------------------------------------------------
// 作業コピーの口は「会話」ではなく「編集コンテキスト」で引く
// ---------------------------------------------------------------------------
// 作業コピー（保存前の AI 変更 + ユーザーの手編集）が属するのは
// **どのサイトの・どのテーマを・誰が編集しているか**であって、
// どの会話で喋ったかではない。
//
// 会話（chat_token）を鍵にしていた頃の実害:
//   ・会話を切り替えている間、その未保存 AI 変更を破棄する入口が無い
//   ・戻ってくると古い作業コピーが復活し、その間に別の会話で保存した
//     内容を上書きする
//   ・同じサイト・同じテーマを 2 タブで開くと別々の作業コピーが育ち、
//     最後に保存した方が勝つ
//
// ⚠ **user は載せない。** 後端が Authorization ヘッダから引く。
//   ここに載せられるようにすると他人の作業コピーが読める。
//
// ⚠ 会話が無くても引ける（切り替え中 / 新規会話 / 別テーマの会話を
//   閲覧中でも）。chatToken の有無でガードしないこと ——
//   それが「切り替えると破棄できない」の原因だった。

// テーマ不明のコンテキストを URL に載せるための代替文字。
// 後端の ctx_id も空節を同じ文字に潰すので、どちらで来ても同じ対象を指す。
const EMPTY_THEME_PATH = '-';

export function designEditorContextBase(address, site_id, theme_code) {
    return `${address}/design-editor/context/${encodeURIComponent(site_id)}`
        + `/${encodeURIComponent(theme_code || EMPTY_THEME_PATH)}/v3`;
}

async function getContextJson(base, path, cms_token, label) {
    const res = await fetch(`${base}${path}`, {
        headers: { Authorization: `Bearer ${cms_token}` },
    });
    if (!res.ok) throw new Error(`${label} failed: ${res.status}`);
    return res.json();
}

// ページ設定項目の「作業コピー」= 保存前の AI 変更を含む settings。
// 正は cms_ai 側（編集コンテキストのストア）にあり、WS の page_config_update は
// その通知に過ぎない。ダイアログを開き直した / 画面をリロードした場合は
// ここから取り直す（WS 通知だけに頼ると取り返せない）。
export async function getDesignEditorPageConfig({
    address, site_id, theme_code, cms_token, page_id,
}) {
    return getContextJson(
        designEditorContextBase(address, site_id, theme_code),
        `/page_config?page_id=${encodeURIComponent(page_id)}`,
        cms_token, 'getDesignEditorPageConfig',
    );
}

// 作業コピーの明示破棄。reason='ai'（AI変更を破棄）/ 'saved'（ユーザー保存後）。
// 呼び出し側は await してから再取得すること（順序が確定する）。
export async function discardDesignEditorPageConfig({
    address, site_id, theme_code, cms_token, page_id, reason,
}) {
    return postDiscard(
        `${designEditorContextBase(address, site_id, theme_code)}/page_config/discard`,
        cms_token,
        { page_id, reason: reason || 'saved' },
    );
}

// ---------------------------------------------------------------------------
// フォーム項目の作業コピー
// ---------------------------------------------------------------------------
// ページ設定と同じ 2 本立て。これがあるおかげで、ダイアログを閉じても
// 画面をリロードしても AI の提案が生き残る。
//
// ⚠ exists は後端の has_working_copy 印で決まる。**items の件数ではない。**
//   ユーザーがダイアログ上で全項目を消した未保存状態は items=[] だが
//   exists=true。ここを件数で判定し直すと、消したはずの項目が
//   保存済みから戻ってくる。

export async function getDesignEditorFormItems({
    address, site_id, theme_code, cms_token, form_id,
}) {
    return getContextJson(
        designEditorContextBase(address, site_id, theme_code),
        `/form_items?form_id=${encodeURIComponent(form_id)}`,
        cms_token, 'getDesignEditorFormItems',
    );
}

export async function discardDesignEditorFormItems({
    address, site_id, theme_code, cms_token, form_id, reason,
}) {
    return postDiscard(
        `${designEditorContextBase(address, site_id, theme_code)}/form_items/discard`,
        cms_token,
        { form_id, reason: reason || 'saved' },
    );
}

// 站点設定作業コピー取得
export async function getDesignEditorSiteConfig({
    address, site_id, theme_code, cms_token,
}) {
    return getContextJson(
        designEditorContextBase(address, site_id, theme_code),
        '/site_config', cms_token, 'getDesignEditorSiteConfig',
    );
}

// 站点設定作業コピー破棄
export async function discardDesignEditorSiteConfig({
    address, site_id, theme_code, cms_token, reason,
}) {
    return postDiscard(
        `${designEditorContextBase(address, site_id, theme_code)}/site_config/discard`,
        cms_token,
        { reason: reason || 'saved' },
    );
}

// ---------------------------------------------------------------------------
// Post 系3種の設定作業コピー取得・破棄
// post_type_id ベースでシャーディングされた作業コピー。
// ---------------------------------------------------------------------------

// 投稿設定作業コピー取得
export async function getDesignEditorPostConfig({
    address, site_id, theme_code, cms_token, post_type_id,
}) {
    return getContextJson(
        designEditorContextBase(address, site_id, theme_code),
        `/post_config?post_type_id=${encodeURIComponent(post_type_id)}`,
        cms_token, 'getDesignEditorPostConfig',
    );
}

// 投稿設定作業コピー破棄
export async function discardDesignEditorPostConfig({
    address, site_id, theme_code, cms_token, post_type_id, reason,
}) {
    return postDiscard(
        `${designEditorContextBase(address, site_id, theme_code)}/post_config/discard`,
        cms_token,
        { post_type_id, reason: reason || 'saved' },
    );
}

// 投稿タイプ設定作業コピー取得
export async function getDesignEditorPostTypeConfig({
    address, site_id, theme_code, cms_token, post_type_id,
}) {
    return getContextJson(
        designEditorContextBase(address, site_id, theme_code),
        `/post_type_config?post_type_id=${encodeURIComponent(post_type_id)}`,
        cms_token, 'getDesignEditorPostTypeConfig',
    );
}

// 投稿タイプ設定作業コピー破棄
export async function discardDesignEditorPostTypeConfig({
    address, site_id, theme_code, cms_token, post_type_id, reason,
}) {
    return postDiscard(
        `${designEditorContextBase(address, site_id, theme_code)}/post_type_config/discard`,
        cms_token,
        { post_type_id, reason: reason || 'saved' },
    );
}

// カテゴリ設定作業コピー取得
export async function getDesignEditorCategoryConfig({
    address, site_id, theme_code, cms_token, post_type_id,
}) {
    return getContextJson(
        designEditorContextBase(address, site_id, theme_code),
        `/post_category_config?post_type_id=${encodeURIComponent(post_type_id)}`,
        cms_token, 'getDesignEditorCategoryConfig',
    );
}

// カテゴリ設定作業コピー破棄
export async function discardDesignEditorCategoryConfig({
    address, site_id, theme_code, cms_token, post_type_id, reason,
}) {
    return postDiscard(
        `${designEditorContextBase(address, site_id, theme_code)}/post_category_config/discard`,
        cms_token,
        { post_type_id, reason: reason || 'saved' },
    );
}

// ---------------------------------------------------------------------------
// コードタブの作業コピー破棄
// ---------------------------------------------------------------------------
// ⚠ **これだけは会話（chat_token）の口のまま。** コードの正はフロントの
// openTabs 側にあり、毎ターン editor_codes として送られて後端の
// template_codes を上書きする。つまりコードは既にサイト+テーマに帰属して
// おり（AI 変更前の控え preAiSource も design-editor-tabs-<site>-<theme> の
// sessionStorage が持つ）、作業コピーのストアへ移す理由が無い。
//
// ただし **editor_codes に載らなくなった対象（タブを閉じた / AI変更を
// 破棄した）は上書きされない。** 残ると後端は幽霊の版を「エディタで開いて
// いるテンプレート」として扱い、view_code / edit_code もそれを読む。
// AI がその上に編集を重ねて push すると保存済みの内容を上書きしてしまう。
export async function discardDesignEditorCode({
    address, chat_token, cms_token, tpl_codes, reason,
}) {
    return postDiscard(
        `${address}/design-editor/chat/${chat_token}/v3/code/discard`,
        cms_token,
        { tpl_codes: tpl_codes || [], reason: reason || DISCARD_REASON_AI },
    );
}

// 走っている推論に停止を要求する。
//
// 停止ボタンは通常 WS を STOP_CLOSE_CODE で閉じるだけだが、それはこの接続の
// worker しか止めない。会話を切り替えた・リロードした後に戻ってきた run は
// **別の接続**が抱えているので、後端の runs の印に cancel を立ててもらう。
// 非同期: 止まった合図は WS の再生フレーム（error + end）で届く。
// cancelled=false は「走っている run が無い」（もう終わった、または死んだ）。
export async function cancelDesignEditorChat({ address, chat_token, cms_token }) {
  const res = await fetch(`${address}/design-editor/chat/${chat_token}/v3/cancel`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${cms_token}` },
  });
  if (!res.ok) throw new Error(`cancelDesignEditorChat failed: ${res.status}`);
  return res.json();
}

// テンプレートコードの作業コピー。
//
// ⚠ 鍵は `<item_type>:<tpl_code>`。tpl_code だけでは一意にならない
//   （cms がテンプレートを種別ごとに別コレクションへ入れるので、
//   レイアウトの `header` とブロックの `header` は別物として共存する）。
//   後端は item_type と tpl_code を別々に受け取り、組み立ては
//   working_copy_store.code_target_id 1 箇所に寄せてある。
export async function getDesignEditorCode({
    address, site_id, theme_code, cms_token, tpl_code, item_type,
}) {
    return getContextJson(
        designEditorContextBase(address, site_id, theme_code),
        `/code?tpl_code=${encodeURIComponent(tpl_code)}`
        + `&item_type=${encodeURIComponent(item_type || 'page')}`,
        cms_token, 'getDesignEditorCode',
    );
}

// コードの作業コピーの明示破棄。
// reason='ai'（AI変更を破棄）/ 'saved'（ユーザー保存後）/ 'deleted'。
export async function discardDesignEditorCodeWorkingCopy({
    address, site_id, theme_code, cms_token, tpl_code, item_type, reason,
    timeoutMs,
}) {
    return postDiscard(
        `${designEditorContextBase(address, site_id, theme_code)}/code/discard`,
        cms_token,
        { tpl_code, item_type: item_type || 'page', reason: reason || 'saved' },
        { timeoutMs },
    );
}

// 設定作業コピーの dirty サマリー取得。
//
// ⚠ 会話ではなく編集コンテキストで引く。だから**会話が無くても**
//   （切り替え中 / 新規会話 / 別テーマの会話を閲覧中でも）
//   リロード後のドット復元ができる。
export async function getDesignEditorConfigDirtySummary({
    address, site_id, theme_code, cms_token, signal,
}) {
    const res = await fetch(
        `${designEditorContextBase(address, site_id, theme_code)}/config_dirty_summary`,
        {
            headers: { Authorization: `Bearer ${cms_token}` },
            signal,
        },
    );
    if (!res.ok) return { dirty: [] };
    return res.json();
}
